
// Open Cart Drawer Function
function openCartDrawer(){
    document.querySelector(".f-cart-drawer").classList.add("f-cart-drawer--active");
  variantSelection()
    // document.querySelector("body").style.overflow = "hidden";
  //stickybtn();
  };
  
// Close Cart Drawer Function
function closeCartDrawer(){
     document.querySelector(".f-cart-drawer").classList.remove("f-cart-drawer--active");
  // document.querySelector("body").style.overflow = "scroll";
  };

//  Function count
async function updateCartItemCount(count = 0){
  // ajax update
  const res = await fetch('/cart',{
    method: "get",
    headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        }
  });
  const cart =  await res.json();
  console.log(cart)
  if(count != 0){
    document.querySelectorAll('.cart-count-bubble').forEach(el =>{
      el.textContent = count;
    })
  }else{
    document.querySelectorAll('.cart-count-bubble').forEach(el =>{
      el.textContent = cart.item_count;
    })
  }  
}



// update Cart Drawer Function  
function updateCartDrawer(){
    fetch('/?section_id=unit-drawer').then( res => res.text() ).then( data =>{
      const html = document.createElement("div");
      html.innerHTML = data;
      const newbox = html.querySelector(".f-cart-drawer").innerHTML;
      document.querySelector('.f-cart-drawer').innerHTML = newbox;
      addCartDrawerListeners();
      removeCartDrawerListeners();
      addCartUpsellListeners();
      variantSelection()
      // stkyTotal()
      
       

      
    }) 
  
};





// update Cart Drawer Function 
function addCartDrawerListeners() {
   // update Quantities
 document.querySelectorAll('.f-cart-drawer-quantity-selector button').forEach((button) => {
   button.addEventListener("click", async () =>{
     // Get line item key
    const rootitem = button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
     const key = rootitem.getAttribute("data-line-item-key");
   // Get new quantity
    
     const currentquantity = Number(button.parentElement.querySelector('input').value);
     const isup = button.classList.contains('f-cart-drawer-quantity-selector-plus');
     const newquanity = isup ? currentquantity + 1 : currentquantity - 1;
     
   // ajax update
    const res = await fetch('/cart/update.js',{
      method: "post",
      headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newquanity } }),
    });
     const cart =  await res.json();
     updateCartItemCount(cart.item_count);
   // update cart
     updateCartDrawer();
   });
   
 });

  
 
  
   document.querySelector(".f-cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // Close Cart
document.querySelectorAll(".f-cart-drawer-header-right-close, .f-cart-drawer")
  .forEach((el) => {
    el.addEventListener("click", () => {
       //  close cart function
     closeCartDrawer();
    });
});
}

// Remove item for cart function
function removeCartDrawerListeners() {
   // update Quantities
 document.querySelectorAll('.f-cart-drawer-item-main-flex-right button').forEach((button) => {
   button.addEventListener("click", async (e) =>{
     e.preventDefault()
     // Get line item key
    const rootitem = button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
     
     const key = rootitem.getAttribute("data-line-item-key");
   // Get new quantity
   
     const newquanity = 0;
     
   // ajax update
    const res = await fetch('/cart/update.js',{
      method: "post",
      headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newquanity } }),
    });
     const cart =  await res.json();
     updateCartItemCount(cart.item_count);
   // update cart
     updateCartDrawer();
   });
   
 });

}

addCartDrawerListeners();
removeCartDrawerListeners();
addCartUpsellListeners();
document.querySelectorAll('.product-form__submit').forEach((btn) => {
  btn.addEventListener("click", async (e) =>{
    // Purple Dot required edit to avoid duplicate event handlers
    const isPreorder = btn.textContent.toLowerCase().includes('pre-order');
    
    if (isPreorder) {
      return
    };
    // End
    
    e.preventDefault();
    let form = btn.closest('form[action="/cart/add"]')
    console.log(new FormData(form));
    // submit form with ajax
   await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });
    //  update cart function
     await updateCartDrawer();
    await updateCartItemCount()
    //  open cart function
     openCartDrawer();
  });
});

document.querySelectorAll('.quick-add__submit').forEach((btn) => {
  btn.addEventListener("click", async (e) =>{
    e.preventDefault();
    let form = btn.closest('form[action="/cart/add"]')
    console.log(new FormData(form));
    // submit form with ajax
   await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });
    //  update cart function
     await updateCartDrawer();
    await updateCartItemCount()
    //  open cart function
     openCartDrawer();
  });
});




// selecct change button id

function variantSelection(){
  document.querySelectorAll('.f-upsale-main select').forEach(select => {
    select.addEventListener('change',()=>{
      let parentDiv = select.closest('.f-upsale-main')
      let btn = parentDiv.querySelector('.f-upsale-add')
      btn.setAttribute('data-variant-id',select.value);
    })
  })
}

document.querySelectorAll('#cart-icon-bubble').forEach(a => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      addCartDrawerListeners();
      removeCartDrawerListeners();
      addCartUpsellListeners();
      
   // update cart
     updateCartDrawer();
      openCartDrawer();
      
    });
});


// upsale function
function addCartUpsellListeners() {
   // update Quantities
 document.querySelectorAll('.add.f-upsale-add').forEach((button) => {
   button.addEventListener("click", async (e) =>{
    e.preventDefault()
     // Get line item key
     
     const key = button.getAttribute("data-variant-id");
   // Get new quantity
    
     const newquanity = 1;
     
   // ajax update
    const res = await fetch('/cart/update.js',{
      method: "post",
      headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newquanity } }),
    });
     const cart =  await res.json();
     updateCartItemCount(cart.item_count);
   // update cart
     updateCartDrawer();
   });
 });   
 };

window.addToCart = function openCart() {
  addCartDrawerListeners();
      removeCartDrawerListeners();
      addCartUpsellListeners();
      
   // update cart
     updateCartDrawer();
      openCartDrawer();
}


